export class Credentials {
	login: string;
	password: string;
}
